import { OptimizationAlgorithm } from '@/services/bayesianApi/models'
import { OptimizationOptions } from '@/services/bayesianApi/optimizationModels'

export const MAX_ITERATIONS = 100000
export const MAX_TIME_MINUTES = Math.round(23.9 * 60)

export const defaultOptionsStandard: OptimizationOptions = {
  max_time_minutes: undefined,
  max_iteration: 1000,
  tolerance: 0.00000001,
  step_size: 0.0001,
  randomize_initial_probabilities: false,
  number_of_runs: 1,
  inference_algorithm: OptimizationAlgorithm.PGMAX_LBP_GRADIENT,
  run_optimization_analysis: false,
}

export const defaultOptionsForJIT: OptimizationOptions = {
  ...defaultOptionsStandard,
  step_size: 10,
  max_iteration: MAX_ITERATIONS,
  tolerance: 0.00000001,
  inference_algorithm: OptimizationAlgorithm.JIT_JAXOPT_MIRROR_DESCENT,
}

// Default time cap for optimizations Marvin starts when the caller doesn't
// specify one. Matches the digraph OptimizeMenu's "Quick" preset
// (src/components/AppBar/OptimizeMenu/OptimizeMenu.tsx): Marvin runs a quick
// optimization by default and only runs a longer one when the user explicitly
// asks (the start_optimization tool then passes a larger maxTimeMinutes). The
// UI's custom dialog forces an explicit value; Marvin has no human in the loop,
// so it must never submit unbounded.
export const MARVIN_DEFAULT_MAX_TIME_MINUTES = 3
